import { HttpClient, HttpParams } from '@angular/common/http';
import { HEADERS } from '../../api/api-headers';

import { Dashboard } from '../models/core.models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WidgetViewProperties } from './feed.service';
import { toFormBody } from 'src/app/api/api-utils';

export interface CopyDashboardParams {
  workspace_id: string;

  // Single or multi dashboard copy
  object_ids: string[];

  // Used when copying one dashboard
  title?: string;
  description?: string;

  // Used when copying multiple dashboards
  prefix?: string;

  duplicateExportSchedules?: boolean;
  duplicatePermissions?: boolean;
}

export interface CopyDashboardResponse {
  dashboards: Dashboard[];
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  saveDashboardSettings(
    dashboardId: string,
    viewProperties: WidgetViewProperties,
  ) {
    const headers = HEADERS.formUrlEncoded;

    let httpParams = toFormBody({ view_properties: viewProperties });

    // Make the HTTP PATCH request with the URL-encoded parameters
    return this.http.patch(
      `/dashboard/${dashboardId}/context_menu_options`,
      httpParams,
      {
        headers,
      },
    );
  }
}
